import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage, injectIntl } from 'react-intl';
import Immutable from 'immutable';

import './ContentNoticesSummary.scss';

export function ContentNoticesSummary({ summary, intl }) {
  const totalUsers = summary.getIn(['contentAdvisories', 'totalUsers']);
  const totalsByType = summary.getIn(['contentAdvisories', 'totalsByType']);

  function renderLabel() {
    return (
      <div className="summary-label">
        <FormattedMessage id="user_contribution_total_count" values={{ count: totalUsers }} />
      </div>
    );
  }

  function renderSummary() {
    const summaryList = Immutable.List(totalsByType)
      .map(([type, total]) =>
        Immutable.Map({
          type,
          total,
          label: intl.formatMessage({ id: `${type}_advisory_type` })
        })
      )
      .filter(summaryType => summaryType.get('total'))
      .sort((a, b) => b.get('total') - a.get('total') || (b.get('label') < a.get('label') ? 1 : -1));
    return (
      <div className="content-notices-summary">
        {summaryList.map(summaryType => (
          <span className="content-notices-category" key={summaryType.get('type')}>{`${summaryType.get(
            'label'
          )} (${summaryType.get('total')})`}</span>
        ))}
      </div>
    );
  }

  return (
    <div className="cp-content-notices-summary">
      {renderSummary()}
      {renderLabel()}
    </div>
  );
}

ContentNoticesSummary.propTypes = {
  summary: ImmutablePropTypes.map.isRequired
};

export default injectIntl(ContentNoticesSummary);
